function checkValue(value, message = 'Invalid id') {
  if (value == null) {
    throw new Error(message);
  }

  return value;
}

class Selectors {
  constructor(state) {
    this._state = state;
  }

  getPayment() {
    return this._state.payment;
  }

  getShop() {
    return this._state.shop;
  }

  getPayMethods() {
    return this._state.payMethods;
  }

  getPayMethod(id) {
    const payMethod = checkValue(this.getPayMethods()[id]);

    return {
      id,
      ...payMethod,
    };
  }

  getPayWaysForPayMethod(pmId) {
    return checkValue(this.getPayMethod(pmId).payWays);
  }

  getPayMethodIdByDefaultPayWay(payWayId) {
    const payMethods = this.getPayMethods();

    return checkValue(
      Object.keys(payMethods).find(
        (pmId) => payWayId === payMethods[pmId].defaultPayWay
      )
    );
  }

  getPayMethodByPayWay(payWayId) {
    const pmId = checkValue(this.getPayWay(payWayId).pmId);

    return this.getPayMethod(pmId);
  }

  getPayWays() {
    return this._state.payWays;
  }

  getPayWay(id) {
    const payWay = checkValue(this.getPayWays()[id]);

    return {
      id,
      ...payWay,
    };
  }

  getSelectedPayWay() {
    const payWays = this.getPayWays();

    const selectedPayWayId = checkValue(
      Object.keys(payWays).find((pwId) => payWays[pwId].selected),
      'None of pay ways are selected'
    );

    return this.getPayWay(selectedPayWayId);
  }

  getWarning(id) {
    return checkValue(this._state.infos.warnings[id]);
  }

  getDescription(id) {
    return checkValue(this._state.infos.descriptions[id]);
  }

  getManual(id) {
    return checkValue(this._state.infos.manuals[id]);
  }

  getCacheTimeout(type, ...args) {
    let cacheTimeout = checkValue(this._state.cache[type], 'Invalid type');

    let argIndex = 0;
    while (typeof cacheTimeout === 'object' && argIndex <= args.length - 1) {
      cacheTimeout = checkValue(cacheTimeout[args[argIndex]]);

      argIndex++;
    }

    return checkValue(cacheTimeout);
  }

  getInvoice() {
    return this._state.invoice;
  }
}

export default function select(state) {
  return new Selectors(state);
}
